import { render } from "./GpaTrendsByYearOfStudy.vue?vue&type=template&id=2e927ce2"
import script from "./GpaTrendsByYearOfStudy.vue?vue&type=script&lang=js"
export * from "./GpaTrendsByYearOfStudy.vue?vue&type=script&lang=js"
script.render = render

export default script